<template>
    <div class="filter-panel">
        <div
            class="filter-panel__fields"
            :style="{ gridTemplateColumns: `repeat(${columns}, 1fr)` }"
        >
            <!-- поля фильтра -->
            <slot></slot>
        </div>

        <div class="filter-panel__actions">
            <div class="filter-panel__actions-left">
                <!-- левая часть действий (например, кнопка "Больше фильтров") -->
                <slot name="actions-left">
                    <!--
                        По умолчанию тут можно оставить пусто
                        или добавить какую-то стандартную кнопку,
                        если это когда-то понадобится.
                    -->
                </slot>
            </div>

            <div class="filter-panel__actions-right">
                <!--
                  Слот для правой части действий.
                  Если родительский компонент не передаст
                  ничего в этот слот, отобразятся кнопки
                  "Сбросить фильтр" и "Найти" по умолчаниы
                -->
                <slot name="actions-right">
                    <div class="filter-panel__action-right">
                        <UISimpleButton
                            button-type="clear"
                            @clicked="onReset"
                        >
                            Сбросить фильтр
                        </UISimpleButton>
                    </div>

                    <div class="filter-panel__action-right">
                        <UISimpleButton @clicked="onSearch">
                            Найти
                        </UISimpleButton>
                    </div>
                </slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { defineProps, defineEmits } from 'vue';
    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';

    defineProps({
        columns: {
            type: Number,
            default: 3,
        },
    });

    const emit = defineEmits<{
        (e: 'reset'): void,
        (e: 'search'): void,
    }>();

    function onSearch(): void {
        emit('search');
    }

    function onReset(): void {
        emit('reset');
    }
</script>

<style lang="scss" scoped>
    @use './FilterPanel.scss' as *;
</style>
